import image1JPG from "../assets/images/gallery-photos/antelope-1-thumbnail.jpg";
import image1WEBP from "../assets/images/gallery-photos/antelope-1-thumbnail.webp";
import image2JPG from "../assets/images/gallery-photos/antelope-2-thumbnail.jpg";
import image2WEBP from "../assets/images/gallery-photos/antelope-2-thumbnail.webp";
import image3JPG from "../assets/images/gallery-photos/antelope-3-thumbnail.jpg";
import image3WEBP from "../assets/images/gallery-photos/antelope-3-thumbnail.webp";
import image4JPG from "../assets/images/gallery-photos/antelope-4-thumbnail.jpg";
import image4WEBP from "../assets/images/gallery-photos/antelope-4-thumbnail.webp";
import image5JPG from "../assets/images/gallery-photos/antelope-5-thumbnail.jpg";
import image5WEBP from "../assets/images/gallery-photos/antelope-5-thumbnail.webp";
import image6JPG from "../assets/images/gallery-photos/antelope-6-thumbnail.jpg";
import image6WEBP from "../assets/images/gallery-photos/antelope-6-thumbnail.webp";
import image7JPG from "../assets/images/gallery-photos/antelope-7-thumbnail.jpg";
import image7WEBP from "../assets/images/gallery-photos/antelope-7-thumbnail.webp";
import image8JPG from "../assets/images/gallery-photos/antelope-8-thumbnail.jpg";
import image8WEBP from "../assets/images/gallery-photos/antelope-8-thumbnail.webp";
import image9JPG from "../assets/images/gallery-photos/antelope-9-thumbnail.jpg";
import image9WEBP from "../assets/images/gallery-photos/antelope-9-thumbnail.webp";
import image10JPG from "../assets/images/gallery-photos/antelope-10-thumbnail.jpg";
import image10WEBP from "../assets/images/gallery-photos/antelope-10-thumbnail.webp";
import image11JPG from "../assets/images/gallery-photos/antelope-11-thumbnail.jpg";
import image11WEBP from "../assets/images/gallery-photos/antelope-11-thumbnail.webp";

import geometry1JPG from "../assets/images/graphics/geometry-artwork-1.jpg";
import geometry1WEBP from "../assets/images/graphics/geometry-artwork-1.webp";
import geometry2JPG from "../assets/images/graphics/geometry-artwork-2.jpg";
import geometry2WEBP from "../assets/images/graphics/geometry-artwork-2.webp";
import geometry3JPG from "../assets/images/graphics/geometry-artwork-3.jpg";
import geometry3WEBP from "../assets/images/graphics/geometry-artwork-3.webp";
import geometry4JPG from "../assets/images/graphics/geometry-artwork-4.jpg";
import geometry4WEBP from "../assets/images/graphics/geometry-artwork-4.webp";
import geometry5JPG from "../assets/images/graphics/geometry-artwork-5.jpg";
import geometry5WEBP from "../assets/images/graphics/geometry-artwork-5.webp";
import geometry6JPG from "../assets/images/graphics/geometry-artwork-6.jpg";
import geometry6WEBP from "../assets/images/graphics/geometry-artwork-6.webp";
import geometry7JPG from "../assets/images/graphics/geometry-artwork-7.jpg";
import geometry7WEBP from "../assets/images/graphics/geometry-artwork-7.webp";
import geometry8JPG from "../assets/images/graphics/geometry-artwork-8.jpg";
import geometry8WEBP from "../assets/images/graphics/geometry-artwork-8.webp";
import geometry9JPG from "../assets/images/graphics/geometry-artwork-9.jpg";
import geometry9WEBP from "../assets/images/graphics/geometry-artwork-9.webp";
import geometry10JPG from "../assets/images/graphics/geometry-artwork-10.jpg";
import geometry10WEBP from "../assets/images/graphics/geometry-artwork-10.webp";
import geometry11JPG from "../assets/images/graphics/geometry-artwork-11.jpg";
import geometry11WEBP from "../assets/images/graphics/geometry-artwork-11.webp";
import geometry12JPG from "../assets/images/graphics/geometry-artwork-12.jpg";
import geometry12WEBP from "../assets/images/graphics/geometry-artwork-12.webp";

import logos1JPG from "../assets/images/graphics/red-cardinal.png";
import logos1WEBP from "../assets/images/graphics/red-cardinal.webp";
import logos2JPG from "../assets/images/graphics/scfoundation-1.jpg";
import logos2WEBP from "../assets/images/graphics/scfoundation-1.webp";
import logos3JPG from "../assets/images/graphics/scfoundation-2.jpg";
import logos3WEBP from "../assets/images/graphics/scfoundation-2.webp";
import logos4JPG from "../assets/images/graphics/harmoneyes-3.jpg";
import logos4WEBP from "../assets/images/graphics/harmoneyes-3.webp";

import poster1JPG from "../assets/images/graphics/exordium-main-poster-w990.jpg";
import poster1WEBP from "../assets/images/graphics/exordium-main-poster-w990.webp";
import poster2JPG from "../assets/images/graphics/exordium-poster-w990.jpg";
import poster2WEBP from "../assets/images/graphics/exordium-poster-w990.webp";

export const antelopeImages = [
  {
    id: 1,
    src: image1JPG,
    srcsetWebp: image1WEBP,
    caption: "Falling Sand",
  },
  {
    id: 2,
    src: image2JPG,
    srcsetWebp: image2WEBP,
    caption: "Horseshoe Bend Right",
  },
  {
    id: 3,
    src: image3JPG,
    srcsetWebp: image3WEBP,
    caption: "The Desert",
  },
  {
    id: 4,
    src: image4JPG,
    srcsetWebp: image4WEBP,
    caption: "The Maze",
  },
  {
    id: 5,
    src: image5JPG,
    srcsetWebp: image5WEBP,
    caption: "Paint Brush",
  },
  {
    id: 6,
    src: image6JPG,
    srcsetWebp: image6WEBP,
    caption: "Sand Wave",
  },
  {
    id: 7,
    src: image7JPG,
    srcsetWebp: image7WEBP,
    caption: "Curiosity",
  },
  {
    id: 8,
    src: image8JPG,
    srcsetWebp: image8WEBP,
    caption: "The Peak",
  },
  {
    id: 9,
    src: image9JPG,
    srcsetWebp: image9WEBP,
    caption: "Rocks and Thorns",
  },
  {
    id: 10,
    src: image10JPG,
    srcsetWebp: image10WEBP,
    caption: "Thorny Sticks",
  },
  {
    id: 11,
    src: image11JPG,
    srcsetWebp: image11WEBP,
    caption: "Horseshoe Bend Left",
  },
];

export const geometryArtwork = [
  {
    id: 1,
    src: geometry1JPG,
    srcsetWebp: geometry1WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 2,
    src: geometry2JPG,
    srcsetWebp: geometry2WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 3,
    src: geometry3JPG,
    srcsetWebp: geometry3WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 4,
    src: geometry4JPG,
    srcsetWebp: geometry4WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 5,
    src: geometry5JPG,
    srcsetWebp: geometry5WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 6,
    src: geometry6JPG,
    srcsetWebp: geometry6WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 7,
    src: geometry7JPG,
    srcsetWebp: geometry7WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 8,
    src: geometry8JPG,
    srcsetWebp: geometry8WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 9,
    src: geometry9JPG,
    srcsetWebp: geometry9WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 10,
    src: geometry10JPG,
    srcsetWebp: geometry10WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 11,
    src: geometry11JPG,
    srcsetWebp: geometry11WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 12,
    src: geometry12JPG,
    srcsetWebp: geometry12WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
];

export const logos = [
  {
    id: 1,
    src: logos1JPG,
    srcsetWebp: logos1WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 2,
    src: logos2JPG,
    srcsetWebp: logos2WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 3,
    src: logos3JPG,
    srcsetWebp: logos3WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
  {
    id: 4,
    src: logos4JPG,
    srcsetWebp: logos4WEBP,
    caption: "Geometry (Thanapoom Phithakjarukorn - tpmusic.com)",
  },
];

export const posters = [
  {
    id: 1,
    src: poster1JPG,
    srcsetWebp: poster1WEBP,
    caption: "Main Exordium Poster",
  },
  {
    id: 2,
    src: poster2JPG,
    srcsetWebp: poster2WEBP,
    caption: "Exordium Poster",
  },
];
